import axios from "axios";

export const envioNuevoRegistro = async (entidad) => {


    let data = JSON.stringify(entidad);

    let config = {
        method: 'post',
        maxBodyLength: Infinity,
        //url: 'https://ingenieria-n8n.iotr9n.easypanel.host/webhook-test/5accfea0-ac3c-4644-80c7-b33018260c80', //test
        url: 'https://ingenieria-n8n.iotr9n.easypanel.host/webhook/5accfea0-ac3c-4644-80c7-b33018260c80',
        headers: {
            'Content-Type': 'application/json'
        },
        data: data
    };

    axios.request(config)
        .then((response) => {
            console.log(JSON.stringify(response.data));
        })
        .catch((error) => {
            console.log(error);
        });


}